import { client as request } from "./request";
import Icon from "@/models/icon";

interface UserAccount {
  email: string;
  password: string;
}

const userDefault = {
  staffId: 0,
  userId: 0,
  name: "",
  email: "",
  icon: new Icon(),
  hasRole: false
};

export class User {
  public staffId: number;
  public userId: number;
  public name: string;
  public email: string;
  public icon: Icon;
  public hasRole: boolean;

  public constructor(params: User = { ...userDefault }) {
    this.staffId = params.staffId;
    this.userId = params.userId;
    this.name = params.name;
    this.email = params.email;
    this.icon = params.icon;
    this.hasRole = params.hasRole;
  }
}

/**
 * アクセストークンを取得する
 */
export async function getAccessToken(params: UserAccount): Promise<string> {
  const res = await request.post("signin.php", {}, params);
  return res.accessToken;
}

export async function signUp(data: FormData) {
  const res = await request.post("signup.php", data);
  return res.accessToken;
}

export async function debugToken() {
  try {
    await request.get("debug_token.php");
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * ユーザー情報を取得する
 */
export async function getProfile() {
  const user = await request.get("get_profile.php");
  return user as User;
}

/**
 * ユーザー情報を保存する
 * @param data name, email
 */
export async function saveProfile(data: FormData) {
  await request.post("save_profile.php", data);
}

/**
 * パスワードを変更する
 * @param data password, currentPassword
 */
export async function changePassword(data: FormData) {
  await request.post("change_password.php", data);
}

/**
 * パスワードリセットを申請する
 */
export async function requestResetPassword(email: string) {
  const d = new FormData();
  d.append("email", email);
  await request.post("request_reset_password.php", d);
}

/**
 * パスワードをリセットする
 */
export async function resetPassword(token: string, password: string) {
  const d = new FormData();
  d.append("token", token);
  d.append("password", password);
  await request.post("reset_password.php", d);
}
